// Legacy Wix URLs (decoded form) -> new paths
const LEGACY_REDIRECTS = {
  "/en/devenir-partenaire": "/partenaires",
  "/en/retours-sur-notre-événement-2025": "/archives/2025",
  "/post/shift-réinventer-un-bâtiment-tertiaire-en-ville-vivante": "/blog/shift-reinventer-un-batiment-tertiaire-en-ville-vivante",
  "/post/centre-pompidou-2030-restaurer-l-icône-réinventer-son-avenir": "/blog/centre-pompidou-2030-restaurer-l-icone-reinventer-son-avenir",
  "/post/unisson-s-vers-une-architecture-bas-carbone-et-du-vivant-changer-la-donne-pour-le-bâtiment-et-l": "/blog/unisson-s-vers-une-architecture-bas-carbone-et-du-vivant",
};

export const legacyTarget = (pathname) => {
  let p = pathname;
  try { p = decodeURIComponent(pathname); } catch { /* keep raw */ }
  p = p.normalize("NFC").replace(/\/+$/, "").toLowerCase();
  return LEGACY_REDIRECTS[p] || null;
};
